import {Category} from '../types/category';

export const categories = [
  {
    text: 'Carnes',
    type: Category.Carnes,
  },
  {
    text: 'Congelados',
    type: Category.Congelados,
  },
  {
    text: 'Aves',
    type: Category.Aves,
  },
  {
    text: 'Frios',
    type: Category.Frios,
  },
  {
    text: 'Mercearia',
    type: Category.Mercearia,
  },
  {
    text: 'Temperos',
    type: Category.Temperos,
  },
  {
    text: 'Kits',
    type: Category.Kits,
  }
];
